export const blockIconsBusinessandpaymentsInsertChartNew = (
	<span className='material-symbols-outlined'>insert_chart</span>
);
